import { render, staticRenderFns } from "./SearchAreaDetailForm.vue?vue&type=template&id=48e66ef2&scoped=true&"
import script from "./SearchAreaDetailForm.vue?vue&type=script&lang=js&"
export * from "./SearchAreaDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchAreaDetailForm.vue?vue&type=style&index=0&id=48e66ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e66ef2",
  null
  
)

export default component.exports